var _path, _path2, _path3, _path4, _path5, _path6;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcTransactionCashDeposit(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 38,
    viewBox: "0 0 39 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.8471 20.2647C13.3503 21.8241 14.1506 23.5008 15.6595 24.064C17.212 24.6448 18.9381 23.8318 19.5137 22.249C20.0883 20.6672 19.2957 18.9131 17.7423 18.3323C16.1888 17.7514 14.6289 15.6849 16.3768 13.5C18.3768 11 22.8768 13.5 21.3768 16.5",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.4888 25.12L15.7438 24.2275M19.4888 11.12L19.1934 12.1539",
    stroke: "#0E5CF4",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M30.5716 24.7749L30.5717 24.7748C33.4536 18.6253 31.759 11.5202 26.5655 8.85258C25.9473 8.535 25.1437 8.17555 24.4932 7.89408C24.1666 7.75272 23.8759 7.62988 23.6628 7.54043C23.5879 7.50898 23.5222 7.4815 23.4683 7.45895C23.4457 7.44951 23.4252 7.44093 23.4069 7.43329C23.3763 7.42047 23.3552 7.41154 23.3414 7.40573C23.3222 7.39765 23.3173 7.39557 23.321 7.39737C17.9516 4.81789 11.293 7.98988 8.37001 14.2247C5.44757 20.4583 7.23053 27.678 12.5935 30.255C12.6926 30.3027 15.8194 31.6954 15.9055 31.7331C21.2248 34.0687 27.6997 30.9008 30.5716 24.7749Z",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M26.6653 22.9768L26.6654 22.9767C29.4506 16.9164 27.7568 9.88829 22.6286 7.37566L22.6286 7.37564C17.4853 4.8561 11.1227 7.95978 8.33513 14.0228C5.54877 20.0832 7.24375 27.1112 12.3718 29.6239C17.5142 32.1446 23.8778 29.0397 26.6653 22.9768Z",
    stroke: "#20242E",
    strokeLinecap: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7L6.50089 7.99951L5.49955 9L4.49911 7.99951L3.5 7",
    stroke: "#20242E",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 8V3",
    stroke: "#20242E",
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcTransactionCashDeposit);
export default __webpack_public_path__ + "static/media/ic-transaction-cash-deposit.113fcbeea786402674e565de3b90a166.svg";
export { ForwardRef as ReactComponent };